import type { StateCreator } from "zustand"

import type { AppState, ProjectSlice } from "@/store/types"

export const createProjectSlice: StateCreator<
  AppState,
  [],
  [],
  ProjectSlice
> = (set) => ({
  projectId: null,
  projectName: "",
  projectCreatedAt: null,
  saveStatus: "idle",
  lastSavedAt: null,
  audioAssetId: null,
  audioMeta: null,
  bgVideoAssetId: null,
  customFontAssetId: null,
  thumbnailDataUrl: null,
  setProject: (projectId, projectName, createdAt) =>
    set({ projectId, projectName, projectCreatedAt: createdAt ?? Date.now() }),
  setProjectName: (projectName) => set({ projectName }),
  setSaveStatus: (saveStatus) => set({ saveStatus }),
  markSaved: (now) => set({ saveStatus: "saved", lastSavedAt: now }),
  clearProject: () =>
    set({
      projectId: null,
      projectName: "",
      projectCreatedAt: null,
      saveStatus: "idle",
      lastSavedAt: null,
      audioAssetId: null,
      audioMeta: null,
      bgVideoAssetId: null,
      customFontAssetId: null,
      thumbnailDataUrl: null,
    }),
  setProjectAssets: (refs) => {
    const patch: Partial<ProjectSlice> = {}
    if ("audioAssetId" in refs) patch.audioAssetId = refs.audioAssetId ?? null
    if ("audioMeta" in refs) patch.audioMeta = refs.audioMeta ?? null
    if ("bgVideoAssetId" in refs)
      patch.bgVideoAssetId = refs.bgVideoAssetId ?? null
    if ("customFontAssetId" in refs)
      patch.customFontAssetId = refs.customFontAssetId ?? null
    if ("thumbnailDataUrl" in refs)
      patch.thumbnailDataUrl = refs.thumbnailDataUrl ?? null
    set(patch)
  },
})
